// Waits for the client on the first render (server-side)
export default async function (context) {
  await context.app.store.dispatch('user/nozzleAuth', context)
  if (!context.app.store.getters['user/auth']) context.redirect('/auth')
}
